import Vue from 'vue'
import ProducaoVuex from 'vuex'

Vue.use(ProducaoVuex)

const user = {}

const showProducaoFiltro: Boolean = false
const contratoId: String = ''
const totalPages: number = 0
const totalRevisao: number = 0
const bloquearGestao: boolean = false
const producaoFiltro = {
  userId: '',
  page: 1,
  fontePagadoraId: '',
  localExecucaoId: '',
  pacienteId: '',
  medicoId: '',
  status: '',
  aguardandoRevisao: false,
  procedimento: '',
  ultimosDias: '0',
  dateStartFormatter: '',
  dateEndFormatter: '',
  datePtBrStart: '',
  datePtBrEnd: '',
  periodo: {
    start: '',
    end: '',
  },
}

const getters = {
  USER: (state: any) => state.user,
  CONTRATO_ID: (state: any) => state.contratoId,
  SHOW_PRODUTO_FILTRO: (state: any) => state.showProducaoFiltro,
  BLOQUEAR_GESTAO: (state: any) => state.bloquearGestao,
  FONTE_PAGADORA_ID_FILTRO: (state: any) => state.producaoFiltro.fontePagadoraId,
  LOCAL_EXECUCAO_FILTRO: (state: any) => state.producaoFiltro.localExecucaoId,
  PACIENTE_ID_FILTRO: (state: any) => state.producaoFiltro.pacienteId,
  MEDICO_FILTRO: (state: any) => state.producaoFiltro.medicoId,
  STATUS_FILTRO: (state: any) => state.producaoFiltro.status,
  PROCEDIMENTO_FILTRO: (state: any) => state.producaoFiltro.procedimento,
  ULTIMOS_DIAS_FILTRO: (state: any) => state.producaoFiltro.ultimosDias,
  PERIODO_FILTRO: (state: any) => state.producaoFiltro.periodo,
  PRODUTO_FILTRO: (state: any) => state.producaoFiltro,
  PAGE: (state: any) => state.producaoFiltro.page,
  DATA_INICIAL_FORMATADA: (state: any) => state.producaoFiltro.dateStartFormatter,
  DATA_FIM_FORMATADA: (state: any) => state.producaoFiltro.dateEndFormatter,
  DATA_INICIAL_PT_BR_FORMATADA: (state: any) => state.producaoFiltro.datePtBrStart,
  DATA_FIM_PT_BR_FORMATADA: (state: any) => state.producaoFiltro.datePtBrEnd,
  TOTAL_PAGES: (state: any) => state.totalPages,
  TOTAL_REVISAO: (state: any) => state.totalRevisao,
}

const actions = { }

const mutations = {
  SET_USER(state: any, value: any) {
    state.user = value
    state.producaoFiltro.userId = value.sub
  },
  SET_SHOW_PRODUTO_FILTRO(state: any, show: Boolean) {
    state.showProducaoFiltro = show
  },
  SET_BLOQUEAR_GESTAO(state: any, show: Boolean) {
    state.bloquearGestao = show
  },
  SET_CONTRATO_ID(state: any, value: String) {
    state.contratoId = value
  },
  SET_FONTE_PAGADORA_ID_FILTRO(state: any, fontePagadoraId: String) {
    state.producaoFiltro.fontePagadoraId = fontePagadoraId
  },
  SET_LOCAL_EXECUCAO_FILTRO(state: any, localExecucaoId: String) {
    state.producaoFiltro.localExecucaoId = localExecucaoId
  },
  SET_PACIENTE_ID_FILTRO(state: any, pacienteId: String) {
    state.producaoFiltro.pacienteId = pacienteId
  },
  SET_MEDICO_FILTRO(state: any, medicoId: String) {
    state.producaoFiltro.medicoId = medicoId
  },
  SET_AGUARDANDO_REVISAO(state: any, status: Boolean) {
    state.producaoFiltro.aguardandoRevisao = status
  },
  SET_STATUS_FILTRO(state: any, status: String) {
    state.producaoFiltro.status = status
  },
  SET_PROCEDIMENTO_FILTRO(state: any, procedimento: String) {
    state.producaoFiltro.procedimento = procedimento
  },
  SET_ULTIMOS_DIAS_FILTRO(state: any, dia: String) {
    state.producaoFiltro.ultimosDias = dia
  },
  SET_PERIODO_FILTRO(state: any, data: any) {
    let today = new Date(data.start)
    if (data.start !== '') {
      state.producaoFiltro.datePtBrStart = `${today.getDate()}/${today.getMonth() + 1}/${today.getFullYear()}`
      state.producaoFiltro.dateStartFormatter = `${today.getFullYear()}-${today.getMonth() + 1}-${today.getDate()}`
    } else {
      state.producaoFiltro.datePtBrStart = ''
    }

    today = new Date(data.end)

    if (data.end !== '') {
      state.producaoFiltro.datePtBrEnd = `${today.getDate()}/${today.getMonth() + 1}/${today.getFullYear()}`
      state.producaoFiltro.dateEndFormatter = `${today.getFullYear()}-${today.getMonth() + 1}-${today.getDate()}`
    } else {
      state.producaoFiltro.datePtBrEnd = ''
    }
    state.producaoFiltro.periodo = data
  },
  SET_PAGE(state: any, page: number) {
    state.producaoFiltro.page = page
  },
  SET_TOTAL_PAGES(state: any, value: number) {
    state.totalPages = value
  },
  SET_TOTAL_REVISAO(state: any, value: number) {
    state.totalRevisao = value
  },
  SET_DATA_START_FORMATADA(state: any, data: String) {
    state.producaoFiltro.dateStartFormatter = data
  },
  SET_DATA_END_FORMATADA(state: any, data: String) {
    state.producaoFiltro.dateEndFormatter = data
  },
  RESET_PRODUTO_FILTRO(state: any) {
    state.producaoFiltro = { ...producaoFiltro }
  },
}

export default new ProducaoVuex.Store({
  state: {
    user: { ...user },
    contratoId: { ...contratoId },
    showProducaoFiltro,
    producaoFiltro: { ...producaoFiltro },
    totalPages,
    totalRevisao,
    bloquearGestao,
  },
  getters,
  actions,
  mutations,
})
